/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ArrowsDown/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ArrowsDown({
  children,
  viewPath = "/DesignSystem/Svgs/ArrowsDown",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ArrowsDown.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-khFXz': alignSelf,'--mt-2-khFXz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-khFXz': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-khFXz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-khFXz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-khFXz': opacity,'--w-7-khFXz': typeof width === 'number' ? `${width}px` : width,'--h-8-khFXz': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="ArrowsDown.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M14.4 7.2L8 13.6 1.6 7.2"
 style={{'--f-9-khFXz': fill,'--s-10-khFXz': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="ArrowsDown.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M14.4 1.6L8 8 1.6 1.6"
 style={{'--f-9-khFXz': fill,'--s-10-khFXz': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}